import { render, staticRenderFns } from "./TermOfService.vue?vue&type=template&id=e3795cb6&"
import script from "./TermOfService.vue?vue&type=script&lang=ts&"
export * from "./TermOfService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports